import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_QUEUE_SERVICE_BASE,
  async loadQueues() {
    await authentication.isAuthenticated();
    const response = await axios.get(this.baseUrl + "/GetQueues", {
      headers: {
        Authorization: `Bearer ${authentication.getToken()}`
      }
    });
    return response.data;
  },
  async loadQueueDetails(workflow) {
    await authentication.isAuthenticated();
    const response = await axios.get(
      this.baseUrl + "/GetQueueDetails?workflow=" + workflow,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async loadHistory(hoursBack) {
    await authentication.isAuthenticated();
    const response = await axios.get(
      this.baseUrl + "/GetPostponeQueueAudit?hoursBack=" + hoursBack,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async postponeQueues(postponeData) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      this.baseUrl + "/PostponeQueues",
      postponeData,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async loadClients() {
    await authentication.isAuthenticated();
    const response = await axios.get(
      process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetClients",
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async loadCarriers() {
    await authentication.isAuthenticated();
    const response = await axios.get(
      process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetCarriers",
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async getEngagementTime() {
    await authentication.isAuthenticated();
    const response = await axios.get(this.baseUrl + "/GetEngagementTimes", {
      headers: {
        Authorization: `Bearer ${authentication.getToken()}`
      }
    });
    return response.data;
  },
  async setEngagementTime(payload) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      this.baseUrl + "/SetEngagementTimes",
      payload,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  }
};
